import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { Card, List, Popconfirm, Space, Typography } from 'antd';
import { Box } from 'components/Box/Box';
import { Button, Text } from 'components';
import React from 'react';
import { StatusNewsItem } from '../pages/AdminPage';

export type StatusNewsListProps = {
  items: StatusNewsItem[];
  loading: boolean;
  onToggleEnabled: (id: string, enabled: boolean) => void;
  onEdit: (item: StatusNewsItem) => void;
  onDelete: (id: string) => void;
};

const StatusNewsList: React.FC<StatusNewsListProps> = ({
  items,
  loading,
  onToggleEnabled,
  onEdit,
  onDelete,
}) => (
  <List
    loading={loading}
    dataSource={items}
    renderItem={(item) => (
      <List.Item key={item.id}>
        <Box width="100%">
          <Space
            style={{
              width: '100%',
              justifyContent: 'space-between',
              marginBottom: 8,
            }}
          >
            <Space>
              {item.title && (
                <Box width="100%" display="flex" flexDirection="row">
                  <Box marginRight="4px">
                    <Text size="p2">Title: </Text>
                  </Box>
                  <Text size="p2" bold>
                    {item.title}
                  </Text>
                </Box>
              )}
              <Button
                type="ghost"
                icon={<EditOutlined />}
                onClick={() => onEdit(item)}
              >
                Edit
              </Button>
              <Popconfirm
                title="Are you sure to delete this item?"
                onConfirm={() => onDelete(item.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  danger
                  type="text"
                  icon={<DeleteOutlined />}
                  size="small"
                />
              </Popconfirm>
            </Space>
            <Space>
              <Text size="ui1">Priority: {item.priority}</Text>
              {/* {item.enabled ? (
                <Text size="ui1">Status: (Enabled)</Text>
              ) : (
                <Text size="ui1">Status: (Disabled)</Text>
              )} */}
              <Button
                onClick={() => onToggleEnabled(item.id, !item.enabled)}
                type={item.enabled ? 'primary' : 'default'}
              >
                {item.enabled ? 'Disable' : 'Enable'}
              </Button>
            </Space>
          </Space>
          <Card
            key={item.id}
            style={{
              width: '100%',
              background:
                item.type === 'info'
                  ? '#e6f7ff'
                  : item.type === 'success'
                  ? '#f6ffed'
                  : item.type === 'error'
                  ? '#fff1f0'
                  : '#fff',
              borderColor:
                item.type === 'info'
                  ? '#91d5ff'
                  : item.type === 'success'
                  ? '#b7eb8f'
                  : item.type === 'error'
                  ? '#ffa39e'
                  : '#f0f0f0',
            }}
            size="small"
            bodyStyle={{ padding: 12 }}
          >
            <Space align="start">
              {item.type === 'info' && (
                <InfoCircleOutlined
                  style={{ color: '#1890ff', marginTop: 3 }}
                />
              )}
              {item.type === 'success' && (
                <CheckCircleOutlined
                  style={{ color: '#52c41a', marginTop: 3 }}
                />
              )}
              {item.type === 'error' && (
                <CloseCircleOutlined
                  style={{ color: '#ff4d4f', marginTop: 3 }}
                />
              )}
              <div>
                <Text
                  size="p2"
                  color={
                    item.type === 'info'
                      ? 'info'
                      : item.type === 'success'
                      ? 'success'
                      : item.type === 'error'
                      ? 'danger'
                      : 'heading'
                  }
                >
                  {item.text}
                </Text>
                {item.linkText && item.linkUrl ? (
                  <Button
                    type="link"
                    href={item.linkUrl}
                    target="_blank"
                    size="small"
                    style={{ paddingLeft: 0 }}
                  >
                    {item.linkText}
                  </Button>
                ) : null}
              </div>
            </Space>
          </Card>
        </Box>
      </List.Item>
    )}
  />
);

export default StatusNewsList;
